import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "store", "staffId", "staffInput", "staffDatalist" ]
  static values = { staffs: Array }

  connect() {
    this.filterStaffOptions()
  }

  filterStaffOptions() {
    const storeId = this.hasStoreTarget ? this.storeTarget.value : ""
    const visibleStaffs = this.staffsValue.filter((staff) => {
      if (!storeId) return true

      return staff.store_ids.includes(parseInt(storeId, 10))
    })

    this.staffDatalistTarget.innerHTML = ""
    visibleStaffs.forEach((staff) => {
      const option = document.createElement("option")
      option.value = staff.name
      option.dataset.staffId = staff.id
      this.staffDatalistTarget.append(option)
    })

    this.syncStaffId()
  }

  selectStaff() {
    this.syncStaffId()
  }

  syncStaffId() {
    const value = this.staffInputTarget.value
    const option = Array.from(this.staffDatalistTarget.options).find((opt) => opt.value === value)

    if (option) {
      this.staffIdTarget.value = option.dataset.staffId
    } else {
      this.staffIdTarget.value = ""
    }
  }
}
